import { useState, useEffect } from 'react';
import { InteractionManager } from 'react-native';
import { useSelector } from 'react-redux';
import CashCounter from './CashCounter';
import Home from './Home';


const Init = ({ navigation, route }) => {
    const isTablet = useSelector((state) => state.info?.isTablet);
    const [interactionCompleted, setIntersectionCompleted] = useState(false);

    useEffect(() => {
        const task = InteractionManager.runAfterInteractions(() => setIntersectionCompleted(true));
        return () => task.cancel();
    }, []);

    if (!interactionCompleted || isTablet == null) { return null; }
    return isTablet
        ? <CashCounter navigation={navigation} route={route} />
        : <Home navigation={navigation} route={route} />;
};

export default Init;
